/* istanbul ignore file */
export * from './BonusPoints';
